module.exports = __webpack_public_path__ + "static/media/golf-carousel-2.36824832.jpg";